import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Communication from './communication';
import InfoPopup from 'components/info-popup/info-popup';

class CommunicationController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showInfoPopup: false
		};
	}


	/**
	 * Type answer to questions
	 * @param {object} event 
	 */
	// TODO: It might make sense to also save input locally in case of slow internet
	handleInputText = (event) => {
		if (this.props.isFacilitator) return;
		
		let answerId = event.target.name;
		let answerValue = event.target.value; 
		let communicationAnswers = [];
		if (this.props.group.communicationAnswers) {
			communicationAnswers = JSON.parse(JSON.stringify(this.props.group.communicationAnswers));
		}
		let answerIndex = communicationAnswers.findIndex((answer) => {return (answer.id === answerId);});

		/* Update answer */
		if (answerIndex >= 0) {
			/* Question already answered, update answer */
			communicationAnswers[answerIndex].value = answerValue;
		} else {
			/* First time question is answered */
			communicationAnswers.push({id: answerId, value: answerValue});
		}

		/* Update database */
		this.props.updateGroup({communicationAnswers: communicationAnswers});
	};


	/**
	 * Hide / show info popup
	 */
	toggleInfoPopup = (show = null) => {
		let showInfoPopup = !this.state.showInfoPopup;
		if (show !== null) showInfoPopup = show;
		this.setState({ showInfoPopup, delayDealingCards: false });
	};

	/**
	 * Render component 
	 */
	render() {
		return (
			<>
				<Communication
					game={this.props.game}
					group={this.props.group}
					handleGoToPage={this.props.handleGoToPage}
					handleInputText={this.handleInputText}
					confirmAndContinue={this.props.confirmAndContinue}
					toggleInfoPopup={this.toggleInfoPopup}
				/>
				{this.state.showInfoPopup && <InfoPopup
					canToggle={true}
					game={this.props.game}
					gameStep={this.props.group.gameStep}
					toggleInfoPopup={this.toggleInfoPopup}
					handleLogout={null}
				/>}	
			</>
		);
	}
}

CommunicationController.propTypes = {
	isFacilitator: PropTypes.bool.isRequired,
	game: PropTypes.object.isRequired,
	group: PropTypes.object.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
	updateGroup: PropTypes.func.isRequired,
	confirmAndContinue: PropTypes.func.isRequired,
};

export default CommunicationController;
